import User from 'umg-ember-backend/components/record-explorer/for/user';

<template><User @records={{@model}} @recordType='user' /></template>
